import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bmTextDivider'
})
export class TextDividerPipe implements PipeTransform {

  transform(value: string): string {

    return value.match(/[a-z]*/gi).join(' ');
  }

}
